// Check if the Shopify Cart exists
if (typeof Shopify !== 'undefined' && Shopify.Cart) {
  var cartNoteInput = document.querySelector('[name="note"]');

  // Function to update the cart note both locally and on the server
  function updateCartNote() {
    var cartNote = cartNoteInput.value;
    localStorage.setItem('cartNote', cartNote); // Save the cart note to local storage

    // Update the cart note on the server
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note: cartNote }),
    })
    .then(response => response.json())
    .then(data => console.log('Cart note updated:', data))
    .catch(error => console.error('Error updating cart note:', error));
  }

  if (cartNoteInput) {
    // Retrieve the cart note from local storage (if available)
    var savedCartNote = localStorage.getItem('cartNote');
    if (savedCartNote) {
      cartNoteInput.value = savedCartNote;
    }

    // Add an input event listener to update the cart note
    cartNoteInput.addEventListener('input', updateCartNote);
  }
}


